exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._27pqY{margin-bottom:5px;display:block;color:red;font-size:14px;font-weight:400}._1Rth4{padding:32px}._152wh{margin:0 auto;padding:0;max-width:500px}._1v5dq{text-align:right}._1_gAa{text-align:left}.gQjoL{text-align:center}._1IIgY{padding:0}._35yKS{border-color:#35baef;background-color:#35baef;color:#fff;float:right;font-size:16px}._35yKS:hover{background:rgba(54,50,119,.8)}._35yKS:focus{border-color:#0074c2;box-shadow:0 0 8px rgba(0,116,194,.6)}.op6Sv{border-color:#35baef;background-color:#35baef;color:#fff}._24SJV{padding:9px 27px}.op6Sv:active,.op6Sv:active:focus,.op6Sv:active:hover,.op6Sv:focus,.op6Sv:hover{border-color:#35baef;background-color:#35baef;color:#fff}._2OhE-,._2OhE-:active,._2OhE-:active:focus,._2OhE-:active:hover,._2OhE-:focus,._2OhE-:hover{border-color:#35baef;color:#35baef;background-color:#fff}._1RXVc{padding:5px 0}._2nv2M{border-radius:0;width:100%;display:block;color:#484848;font-size:16px;padding-bottom:12px;border-bottom:1px solid #d9d9d9}._3MUzg{margin-bottom:18px}._3dzAY{padding:10px 35px 10px 10px}._3dzAY,._3kWI2{height:40px;border-radius:4px;font-size:14px;border:1px solid #d9d9d9;background-color:#fff;color:#585858;font-weight:400}._3kWI2{padding:10px 32px 10px 10px}.CvRYL{position:relative;display:inline-block;vertical-align:bottom;margin-right:5px}._32Ibx{overflow:hidden}._2nPgp{font-size:16px;color:#484848;margin:6px 0}._3hjXj{font-size:14px;color:#585858;margin:6px 0;line-height:1.43;font-weight:400}._2jm14{color:#008489}._1K4-3{font-size:16px;line-height:32px}._2jm14:focus,._2jm14:hover{color:#008489;text-decoration:underline}._1FiWf{margin-top:18px}._2L5QB,.dj51A{text-align:right}._2L5QB{margin-bottom:0;margin-top:4px}@media screen and (max-width:640px){._2aLzZ{margin-top:6px}._2L5QB{text-align:left}._3MUzg{margin-bottom:6px}}", ""]);

// exports
exports.locals = {
	"errorMessage": "_27pqY",
	"root": "_1Rth4",
	"container": "_152wh",
	"textAlignRight": "_1v5dq",
	"textAlignLeft": "_1_gAa",
	"textAlignCenter": "gQjoL",
	"noPadding": "_1IIgY",
	"button": "_35yKS",
	"btnPrimary": "op6Sv",
	"btnlarge": "_24SJV",
	"btnPrimaryBorder": "_2OhE-",
	"btnSmall": "_1RXVc",
	"panelHeader": "_2nv2M",
	"formGroup": "_3MUzg",
	"formControlInput": "_3dzAY",
	"formControlSelect": "_3kWI2",
	"select": "CvRYL",
	"formSection": "_32Ibx",
	"captionText": "_2nPgp",
	"labelText": "_3hjXj",
	"modalCaptionLink": "_2jm14",
	"modalCaptionLinkLarge": "_1K4-3",
	"spaceTop3": "_1FiWf",
	"textRight": "dj51A",
	"textAlign": "_2L5QB",
	"smSpace": "_2aLzZ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/EditProfileForm/EditProfileForm.css
// module id = 2529
// module chunks = 15